import './Spinner.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import { ScaleLoader } from 'react-spinners';
import { Brand100 } from '../../utils/colors';

interface SpinnerProps {
  size?: number;
  color?: string;
}

// Default vals for ScaleLoader are height=35 & width=4
const LOADER_SIZE_RATIO = 4 / 35;

export const Spinner = ({ size = 35, color = Brand100 }: SpinnerProps): ReactNode => (
  <div className='bpm-spinner'>
    <ScaleLoader width={size * LOADER_SIZE_RATIO} height={size} color={color} />
  </div>
);

interface FullPageSpinnerProps {
  transparent?: boolean;
  fixed?: boolean;
}

export const FullPageSpinner = ({ transparent, fixed }: FullPageSpinnerProps): ReactNode => (
  <div
    className={cn('bpm-full-page-spinner', { transparent, fixed })}
    data-testid='full-page-spinner'
  >
    <Spinner />
  </div>
);
